module.exports = __webpack_public_path__ + "static/EWY_Shibon_Social_Video-225bd934458379bb120ae169c216c0fa.mp4";